import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAC-FpcV1mLkW6oThAl_twQCWl4c1Vw71g",
  authDomain: "buildjamaica-8ff3f.firebaseapp.com",
  projectId: "buildjamaica-8ff3f",
  storageBucket: "buildjamaica-8ff3f.appspot.com",
  messagingSenderId: "441131528153",
  appId: "1:441131528153:web:3bee63e6d64c7dd24333c8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

// Use emulator only when explicitly enabled to allow localhost to hit prod when desired.
if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  const useEmu = process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true';
  if (useEmu && (host === 'localhost' || host === '127.0.0.1')) {
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  }
}


export { db, auth, functions };